import { useEffect, useState } from 'react';
import api from '../../../platform/api/api';
import './ExpertInfo.css';

export default function ExpertInfo() {
  const [data, setData] = useState();

  useEffect(() => {
    api.get(`/conversations/all-conversations-stats`).then((response) => {
      if (response.data.length > 0) {
        const sortedData = response.data.sort((r1, r2) =>
          r1.platform.name.localeCompare(r2.platform.name)
        );

        setData(sortedData);
      }
    });
  }, []);

  return (
    <main className='expert-info_wrapper'>
      <h3 className='mailbox-title'>Ekspert Panel Hub</h3>
      <table className='expert-info_table'>
        <thead>
          <tr>
            <th>Kurs</th>
            <th>Nowy</th>
            <th>Zakończony</th>
            <th>Odczytany</th>
            <th>Nowa wiadomość</th>
          </tr>
        </thead>
        <tbody>
          {data ? (
            data.map((row, idx) => (
              <tr key={idx}>
                <td>
                  <a href={row.platform.link} target='_blank' rel='noreferrer'>
                    {row.platform.name}
                  </a>
                </td>
                <td className='expert-info_table_new'>
                  <span>{row.data.new ?? 0}</span>
                </td>
                <td>
                  <span>{row.data.completed ?? 0}</span>
                </td>
                <td>
                  <span>{row.data.seen ?? 0}</span>
                </td>
                <td className='expert-info_table_new2'>
                  <span>{row.data.new_in_conversation ?? 0}</span>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5} className='expert-info_error'>
                Unable to fetch data
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </main>
  );
}
